import React from 'react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';


import {
    Button,
    DataForm,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';

export default function TaroffOrdersNew(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = async () => {};
    return (
        <PanelBox>
            <Title>ایجاد سفارش</Title>
            <DataForm>
                <Button onClick={handlecomp1}>ذخیره</Button>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
